import { ConfirmDialog, ConfirmDialogProps } from "primereact/confirmdialog";
import React from "react";
import { pluginComponentStore } from "./PluginComponents";
import { UserInfo } from "./UserInfo";
import { concatClassnames } from "./util";

export interface WsConfirmDialogProps extends ConfirmDialogProps {
  userInfo: UserInfo;
}

export function wsConfirmDialog(
  props: WsConfirmDialogProps
): Promise<boolean | null> {
  return new Promise((r) => {
    let resolve = (result: boolean | null) => {
      pluginComponentStore.remove(dialogId);
      r(result);
    };

    const { userInfo, ...rest } = props;

    const dialog = () => {
      return (
        <ConfirmDialog
          visible
          rejectLabel={props.userInfo.locStore.id("187681e35381").loc("Nei")}
          acceptLabel={props.userInfo.locStore.id("d9fed4f5b386").loc("Ja")}
          accept={() => resolve(true)}
          reject={() => resolve(false)}
          onHide={() => resolve(null)}
          className={concatClassnames([
            rest.className,
            "cvp-confirmation-dialog",
            !rest.icon && "cvp-confirmation-dialog-no-icon",
          ])}
          {...rest}
        />
      );
    };
    const dialogId = pluginComponentStore.add(dialog);
  });
}
